import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
 
@Component({
  selector: 'app-exam-eligibility',
  templateUrl: './exam-eligibility.component.html',
  styleUrls: ['./exam-eligibility.component.scss']
})
export class ExamEligibilityComponent implements OnInit {
  examList: any;
  CountinuButton =false;
 
  constructor(private fb: FormBuilder,
    public umsService: UmsService,
    public dialogRef: MatDialogRef<ExamEligibilityComponent>,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService, @Inject(MAT_DIALOG_DATA) public data: any
  ){}
 
 
 
  getRowClass(remark: string): string {
    return remark ? 'table-danger' : 'table-success';
  }
 
  ngOnInit(): void {
    this.spinner.show();
    if(this.data == "PreAdmissionQualification"){
      this.getEligibility(0)
    }
    else{
      this.spinner.hide()
    }
    this.CountinuButton = true;
    this.prepopulationOfAddmission();
    this.getRgId();
  }
 
  onClose(response: boolean) {
    this.dialogRef.close(response);
  }
 
  prepopulationOfAddmission() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        // if(this.data == "PreAdmissionQualification"){
        //   this.getEligibility(res.data[0]['StuEmId'])
        // }
      }else{
        this.spinner.hide()
      }
    })
  }
 
  getRgId() {
    this.spinner.show();
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");;
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.examform(res.data[0]['RgId'])
      }
      else {
        this.spinner.hide()
      }
    })
  }
  examform(RgId) {
    this.spinner.show();
    const payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
        
        if(res.status){
          this.getEligibility(res.data[0]['EmId'])
        }else{
          this.spinner.hide()
        }
      });
 
  }
 
  getEligibility(EmId){
    this.spinner.show();
    let payload = {};
    payload['StudentId'] = parseInt(sessionStorage.getItem('StudentPersonalId'))
    payload['SessionNo'] = parseInt(sessionStorage.getItem('session'))
    payload['ExamId'] = parseInt(EmId)
    payload['RegId'] = 0
    payload['RuleResult'] = 'A'
    payload['EligibilityFor'] = this.data;
    this.umsService.CheckExamEligibility(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.examList = res.data;
        if (this.examList.every(exam => exam.Remark !== 'Failed')) {
          this.CountinuButton = false;
      } else {
          this.CountinuButton = true; // or any other handling you need
      }
      }
      else{
        this.spinner.hide()
        this.examList = []
        this.CountinuButton = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CountinuButton = false;
    })
  }
 
  areAllRemarksEmpty(): boolean {
    return this.examList.every(exam => exam.Remark !== 'Failed');
  }
 
  SelectData(value){
    if(value == "Back"){
      this.dialogRef.close();
    }
   
  }
 
}
 